// 黃大仙簽文數據 (香港黃大仙廟60簽)
export interface FortuneSign {
  id: number;
  title: string;
  poem: string;
  meaning: string;
  aspects: {
    家宅: string;
    事業: string;
    學業: string;
    命運: string;
    健康: string;
    感情: string;
  };
  level: '上上' | '上中' | '上下' | '中上' | '中中' | '中下' | '下上' | '下中' | '下下';
}

export const fortuneSigns: FortuneSign[] = [
  {
    id: 1,
    title: "第一簽 上上 古人開天闢地",
    poem: "混沌初開天地分\n日月星辰次第新\n萬物生成皆有序\n人生何處不逢春",
    meaning: "此簽大吉，如天地初開，萬象更新。凡事皆有新的開始，前程似錦。",
    aspects: {
      家宅: "家運昌隆，和睦安康，有添丁之喜",
      事業: "事業蒸蒸日上，有貴人相助，宜把握機會",
      學業: "學業進步，考試順利，名列前茅",
      命運: "運勢極佳，諸事順遂，心想事成",
      健康: "身體健康，精神飽滿，無病無災",
      感情: "感情美滿，有情人終成眷屬，婚姻幸福"
    },
    level: '上上'
  },
  {
    id: 2,
    title: "第二簽 上中 古人鑽木取火",
    poem: "鑽木取火古人傳\n星星之火可燎原\n只要功夫深似海\n鐵杵磨成繡花針",
    meaning: "此簽勉勵持之以恆，雖然開始困難，但只要堅持不懈，必能成功。",
    aspects: {
      家宅: "家庭和睦，但需耐心經營，漸入佳境",
      事業: "事業需要努力耕耘，不可急躁，終有成就",
      學業: "學習需要刻苦用功，勤能補拙，必有所成",
      命運: "運勢平穩上升，需要耐心等待時機",
      健康: "身體基本健康，注意勞逸結合",
      感情: "感情需要用心經營，真誠相待必有回報"
    },
    level: '上中'
  },
  {
    id: 3,
    title: "第三簽 上下 古人結草銜環",
    poem: "結草銜環報恩深\n滴水之恩湧泉報\n善有善報天理循\n積德行善福自臨",
    meaning: "此簽提醒要懂得感恩，多行善事，必有福報。",
    aspects: {
      家宅: "家庭祥和，長輩健康，子孫孝順",
      事業: "事業穩定，得人心者得天下，宜以德服人",
      學業: "學業順利，師長提攜，同窗相助",
      命運: "運勢良好，貴人相助，福報漸至",
      健康: "身心健康，心情愉悅，延年益壽",
      感情: "感情穩定，相敬如賓，白頭偕老"
    },
    level: '上下'
  },
  {
    id: 4,
    title: "第四簽 中上 古人投筆從戎",
    poem: "投筆從戎志氣高\n男兒立志在四方\n功名富貴皆可得\n只待時來運轉好",
    meaning: "此簽鼓勵要有遠大志向，勇於追求理想，時機成熟必能成功。",
    aspects: {
      家宅: "家運漸旺，男丁有出息，光宗耀祖",
      事業: "事業有成，宜向外發展，前程遠大",
      學業: "學業有成，可考慮深造或專業發展",
      命運: "運勢向上，志向遠大者必有所成",
      健康: "身體強健，精力充沛，適合拼搏",
      感情: "感情需要主動，勇敢表達必有回應"
    },
    level: '中上'
  },
  {
    id: 5,
    title: "第五簽 中中 古人守株待兔",
    poem: "守株待兔古人愚\n坐享其成豈可求\n天道酬勤是真理\n勤勞致富福自修",
    meaning: "此簽警示不可坐享其成，要勤勞努力，天道酬勤。",
    aspects: {
      家宅: "家庭平穩，但不可懈怠，需要努力維持",
      事業: "事業平平，需要主動出擊，不可守株待兔",
      學業: "學業一般，需要加倍努力，不可偷懶",
      命運: "運勢平平，需要自己努力改變現狀",
      健康: "身體無大礙，但需要注意保養",
      感情: "感情平淡，需要主動經營，增進感情"
    },
    level: '中中'
  },
  {
    id: 6,
    title: "第六簽 中下 古人刻舟求劍",
    poem: "刻舟求劍不知變\n固執己見路難行\n時移世易須應變\n靈活變通始得成",
    meaning: "此簽提醒要懂得變通，不可固執己見，要隨機應變。",
    aspects: {
      家宅: "家庭關係需要調整，不可過於固執",
      事業: "事業遇到瓶頸，需要改變策略和方法",
      學業: "學習方法需要調整，不可死讀書",
      命運: "運勢需要轉變思維，靈活應對",
      健康: "身體需要調養，改變不良習慣",
      感情: "感情需要溝通，不可一意孤行"
    },
    level: '中下'
  },
  {
    id: 7,
    title: "第七簽 下上 古人臥薪嘗膽",
    poem: "臥薪嘗膽志不移\n十年磨劍為今時\n苦盡甘來終有日\n一朝得志震天威",
    meaning: "此簽勉勵在困境中要堅持，經過磨練必能成功。",
    aspects: {
      家宅: "家庭暫時困難，但堅持必能改善",
      事業: "事業處於低潮，需要堅持和努力",
      學業: "學習遇到困難，但不可放棄",
      命運: "運勢暫時不佳，但堅持必有轉機",
      健康: "身體需要調養，注意休息",
      感情: "感情遇到考驗，真愛必能度過難關"
    },
    level: '下上'
  },
  {
    id: 8,
    title: "第八簽 下中 古人畫餅充飢",
    poem: "畫餅充飢豈能飽\n空想無益徒煩惱\n腳踏實地方為上\n實幹興邦是正道",
    meaning: "此簽警示不可空想，要腳踏實地，實際行動才能成功。",
    aspects: {
      家宅: "家庭需要實際行動改善，不可只是空想",
      事業: "事業需要實幹，空談無益",
      學業: "學習需要踏實用功，不可投機取巧",
      命運: "運勢需要實際努力改變，不可幻想",
      健康: "身體需要實際保養，不可忽視",
      感情: "感情需要真心付出，不可只是嘴上說說"
    },
    level: '下中'
  },
  {
    id: 9,
    title: "第九簽 下下 古人杞人憂天",
    poem: "杞人憂天自尋煩\n庸人自擾不得安\n放開心胸天地寬\n樂觀面對福自來",
    meaning: "此簽提醒不要過度憂慮，要樂觀面對，心境平和福自來。",
    aspects: {
      家宅: "家庭和睦，不要過度擔心，順其自然",
      事業: "事業平穩，不要杞人憂天，保持信心",
      學業: "學業正常，不要過度焦慮，放鬆心情",
      命運: "運勢平穩，心態決定一切，保持樂觀",
      健康: "身體健康，不要疑神疑鬼，心情愉快",
      感情: "感情穩定，不要胡思亂想，信任對方"
    },
    level: '下下'
  },
  {
    id: 10,
    title: "第十簽 上上 古人金榜題名",
    poem: "十年寒窗苦讀書\n一朝金榜題名時\n春風得意馬蹄疾\n一日看盡長安花",
    meaning: "此簽大吉，學業事業皆有成就，名利雙收。",
    aspects: {
      家宅: "家門榮耀，光宗耀祖，家運昌盛",
      事業: "事業成功，名利雙收，前程似錦",
      學業: "學業有成，金榜題名，前途光明",
      命運: "運勢極佳，心想事成，諸事順利",
      健康: "身心健康，精神飽滿，神采奕奕",
      感情: "感情美滿，佳偶天成，幸福美滿"
    },
    level: '上上'
  },
  // 繼續添加更多簽文...
  {
    id: 11,
    title: "第十一簽 上中 古人鯉魚躍龍門",
    poem: "鯉魚躍過龍門去\n從此身價百倍增\n雲程萬里任翱翔\n富貴榮華享太平",
    meaning: "此簽表示將有重大突破，地位提升，前程遠大。",
    aspects: {
      家宅: "家運轉旺，地位提升，門第光輝",
      事業: "事業突破，升職加薪，前程遠大",
      學業: "學業進步，考試成功，深造有望",
      命運: "運勢大好，地位提升，名利雙收",
      健康: "身體健康，精力旺盛，神清氣爽",
      感情: "感情順利，門當戶對，婚姻美滿"
    },
    level: '上中'
  },
  {
    id: 12,
    title: "第十二簽 上下 古人三顧茅廬",
    poem: "三顧茅廬求賢才\n誠心感動出山來\n君臣際遇千載難\n輔佐明主展奇才",
    meaning: "此簽表示將遇貴人，或有人賞識，要把握機會。",
    aspects: {
      家宅: "家有貴人相助，長輩提攜，家運興旺",
      事業: "事業得貴人助，上司賞識，發展順利",
      學業: "學業得師長指導，同學相助，進步神速",
      命運: "運逢貴人，機會難得，要好好把握",
      健康: "身體健康，有良醫相助，無病無災",
      感情: "感情得長輩祝福，媒人撮合，美滿幸福"
    },
    level: '上下'
  },
  {
    id: 13,
    title: "第十三簽 中上 古人負荊請罪",
    poem: "負荊請罪化干戈\n將相和睦國運昌\n化敵為友真君子\n寬容大度福無疆",
    meaning: "此簽勸人要寬容大度，化解恩怨，和睦相處。",
    aspects: {
      家宅: "家庭和睦，化解矛盾，其樂融融",
      事業: "事業合作，化敵為友，共創雙贏",
      學業: "學習合作，互相幫助，共同進步",
      命運: "運勢轉好，化解糾紛，心情舒暢",
      健康: "身心健康，心情愉悅，延年益壽",
      感情: "感情和好，化解誤會，重歸於好"
    },
    level: '中上'
  },
  {
    id: 14,
    title: "第十四簽 中中 古人愚公移山",
    poem: "愚公移山志不移\n子子孫孫無窮期\n精誠所至金石開\n堅持到底必成功",
    meaning: "此簽勉勵要有恆心毅力，堅持不懈必能成功。",
    aspects: {
      家宅: "家業需要長期經營，世代傳承，終有所成",
      事業: "事業需要堅持，不可半途而廢，終有成就",
      學業: "學習需要恆心，持之以恆，必有所成",
      命運: "運勢需要耐心等待，堅持努力，終見成效",
      健康: "身體需要長期保養，持之以恆，健康長壽",
      感情: "感情需要用心經營，持之以恆，白頭偕老"
    },
    level: '中中'
  },
  {
    id: 15,
    title: "第十五簽 中下 古人塞翁失馬",
    poem: "塞翁失馬焉知非福\n禍福相依理難明\n今日之失明日得\n莫為眼前事憂心",
    meaning: "此簽提醒禍福相依，不要為眼前得失過分憂慮。",
    aspects: {
      家宅: "家庭暫有波折，但禍福相依，不必過憂",
      事業: "事業有得有失，保持平常心，終有轉機",
      學業: "學習有起有伏，不要氣餒，繼續努力",
      命運: "運勢起伏不定，但禍福相依，保持樂觀",
      健康: "身體小有不適，但無大礙，注意調養",
      感情: "感情有波折，但真愛經得起考驗"
    },
    level: '中下'
  },
  {
    id: 16,
    title: "第十六簽 下上 古人孟母三遷",
    poem: "孟母三遷為教子\n環境影響人品格\n近朱者赤近墨黑\n慎選朋友很重要",
    meaning: "此簽提醒環境的重要性，要慎選朋友和環境。",
    aspects: {
      家宅: "家庭環境需要改善，搬遷或裝修有利",
      事業: "工作環境需要改變，換工作或調部門",
      學業: "學習環境很重要，選擇好學校或補習班",
      命運: "運勢受環境影響，改變環境可改運",
      健康: "居住環境影響健康，注意空氣和水質",
      感情: "感情受朋友影響，慎選交友圈子"
    },
    level: '下上'
  },
  {
    id: 17,
    title: "第十七簽 下中 古人掩耳盜鈴",
    poem: "掩耳盜鈴自欺人\n真相豈能永遮掩\n誠實面對是正道\n自欺欺人終害己",
    meaning: "此簽警示不要自欺欺人，要誠實面對現實。",
    aspects: {
      家宅: "家庭問題不可迴避，要誠實面對解決",
      事業: "工作問題要正視，不可自欺欺人",
      學業: "學習成績要實事求是，不可作弊",
      命運: "運勢需要誠實面對，不可逃避現實",
      健康: "身體問題要及時就醫，不可諱疾忌醫",
      感情: "感情問題要坦誠溝通，不可隱瞞欺騙"
    },
    level: '下中'
  },
  {
    id: 18,
    title: "第十八簽 下下 古人井底之蛙",
    poem: "井底之蛙見識淺\n坐井觀天天地小\n走出井口天地寬\n開闊眼界見真章",
    meaning: "此簽提醒要開闊眼界，不可坐井觀天，見識要廣。",
    aspects: {
      家宅: "家庭觀念需要更新，不可過於保守",
      事業: "事業眼光要放遠，不可局限於小圈子",
      學業: "學習要博覽群書，不可閉門造車",
      命運: "運勢需要開闊視野，走出舒適圈",
      健康: "身體需要多運動，不可宅在家裡",
      感情: "感情要開放心胸，不可過於狹隘"
    },
    level: '下下'
  },
  {
    id: 19,
    title: "第十九簽 上上 古人鳳凰于飛",
    poem: "鳳凰于飛翱翔天\n雌雄和鳴樂無邊\n夫妻恩愛如鳳凰\n白頭偕老福綿綿",
    meaning: "此簽大吉，特別利於感情婚姻，夫妻和睦，家庭幸福。",
    aspects: {
      家宅: "家庭和睦，夫妻恩愛，子女孝順",
      事業: "事業順利，夫妻同心，事業有成",
      學業: "學業進步，得配偶支持，專心向學",
      命運: "運勢極佳，感情美滿，諸事順利",
      健康: "身心健康，夫妻相伴，延年益壽",
      感情: "感情極佳，如鳳凰于飛，恩愛無比"
    },
    level: '上上'
  },
  {
    id: 20,
    title: "第二十簽 上中 古人竹報平安",
    poem: "竹報平安喜信來\n家書抵萬金珍貴\n遠方親友皆安好\n心中石頭終放下",
    meaning: "此簽表示將有好消息傳來，遠方親友平安，心情愉悅。",
    aspects: {
      家宅: "家人平安，遠方親友安好，家庭和睦",
      事業: "事業有好消息，合作順利，前景看好",
      學業: "學業有好成績，考試順利，師長滿意",
      命運: "運勢良好，好消息不斷，心情愉快",
      健康: "身體健康，檢查結果良好，無病無災",
      感情: "感情有好消息，可能有喜事臨門"
    },
    level: '上中'
  },
  // 繼續添加到60簽...
  {
    id: 21,
    title: "第二十一簽 上下 古人梅花三弄",
    poem: "梅花三弄雪中開\n不畏嚴寒志不衰\n香自苦寒來更濃\n堅貞品格世人誇",
    meaning: "此簽勉勵在困境中要堅持，品格高尚，終能成功。",
    aspects: {
      家宅: "家庭雖有困難，但品格高尚，終能度過",
      事業: "事業遇挫折，但堅持不懈，終有成就",
      學業: "學習雖困難，但意志堅定，必有所成",
      命運: "運勢雖有波折，但品格堅貞，終見光明",
      健康: "身體雖有小恙，但意志堅強，必能康復",
      感情: "感情雖有考驗，但真心不變，終成正果"
    },
    level: '上下'
  },
  {
    id: 22,
    title: "第二十二簽 中上 古人桃李滿天下",
    poem: "桃李滿天下門生\n教書育人功德深\n春風化雨潤無聲\n德高望重受人尊",
    meaning: "此簽表示德高望重，受人尊敬，教育或指導他人有成。",
    aspects: {
      家宅: "家庭受人尊敬，子女有出息，家風良好",
      事業: "事業受人敬重，下屬忠心，領導有方",
      學業: "學業優秀，可考慮從事教育工作",
      命運: "運勢良好，德高望重，受人尊敬",
      健康: "身心健康，心情愉悅，長壽之相",
      感情: "感情穩定，受人祝福，家庭和睦"
    },
    level: '中上'
  },
  {
    id: 23,
    title: "第二十三簽 中中 古人水滴石穿",
    poem: "水滴石穿非一日\n持之以恆功自成\n莫嫌進步太緩慢\n積少成多見真功",
    meaning: "此簽勉勵要有耐心，持之以恆，積少成多必有成就。",
    aspects: {
      家宅: "家庭需要長期經營，慢慢積累，終有所成",
      事業: "事業需要耐心，一步一腳印，穩步前進",
      學業: "學習需要恆心，日積月累，必有進步",
      命運: "運勢需要耐心等待，持續努力，終見成效",
      健康: "身體需要長期保養，持之以恆，健康長壽",
      感情: "感情需要時間培養，慢慢加深，終成正果"
    },
    level: '中中'
  },
  {
    id: 24,
    title: "第二十四簽 中下 古人朝三暮四",
    poem: "朝三暮四心不定\n見異思遷難成事\n專心一意是正道\n三心二意必敗事",
    meaning: "此簽警示不可三心二意，要專心一意，才能成功。",
    aspects: {
      家宅: "家庭需要專心經營，不可三心二意",
      事業: "事業要專注，不可見異思遷，朝三暮四",
      學業: "學習要專心，不可分心，專注一科",
      命運: "運勢需要專注，不可搖擺不定",
      健康: "身體保養要持續，不可三天打魚兩天曬網",
      感情: "感情要專一，不可朝三暮四，腳踏兩船"
    },
    level: '中下'
  },
  {
    id: 25,
    title: "第二十五簽 下上 古人破釜沉舟",
    poem: "破釜沉舟背水戰\n置之死地而後生\n勇氣決心能移山\n絕境逢生創奇蹟",
    meaning: "此簽勉勵在絕境中要有破釜沉舟的決心，必能逢生。",
    aspects: {
      家宅: "家庭雖有困難，但決心改變，必能翻身",
      事業: "事業雖困難，但背水一戰，必有轉機",
      學業: "學習雖困難，但全力以赴，必能成功",
      命運: "運勢雖低迷，但決心改變，必有轉機",
      健康: "身體雖有病，但積極治療，必能康復",
      感情: "感情雖有危機，但真心挽回，必能重圓"
    },
    level: '下上'
  },
  {
    id: 26,
    title: "第二十六簽 下中 古人南柯一夢",
    poem: "南柯一夢醒來空\n榮華富貴如浮雲\n人生如夢須看破\n莫為虛名累此身",
    meaning: "此簽提醒人生如夢，不要過分追求虛名，要看破紅塵。",
    aspects: {
      家宅: "家庭不要過分追求虛榮，平淡是福",
      事業: "事業不要過分追求名利，知足常樂",
      學業: "學習不要只為名次，重在學到知識",
      命運: "運勢平平，不要過分期望，順其自然",
      健康: "身體健康最重要，不要為名利傷身",
      感情: "感情要真心，不要為虛榮而結合"
    },
    level: '下中'
  },
  {
    id: 27,
    title: "第二十七簽 下下 古人杯弓蛇影",
    poem: "杯弓蛇影疑心重\n無中生有自驚嚇\n心病還須心藥醫\n放下疑慮得安寧",
    meaning: "此簽提醒不要疑神疑鬼，要放下疑慮，心病還須心藥醫。",
    aspects: {
      家宅: "家庭和睦，不要疑神疑鬼，信任家人",
      事業: "事業正常，不要過度猜疑，信任同事",
      學業: "學習正常，不要胡思亂想，專心學習",
      命運: "運勢平穩，不要疑神疑鬼，保持樂觀",
      健康: "身體健康，不要疑病，心情愉快",
      感情: "感情穩定，不要猜疑對方，信任是基礎"
    },
    level: '下下'
  },
  {
    id: 28,
    title: "第二十八簽 上上 古人龍鳳呈祥",
    poem: "龍鳳呈祥瑞氣來\n天降福星照門第\n富貴榮華齊到來\n子孫滿堂樂開懷",
    meaning: "此簽大吉，龍鳳呈祥，富貴榮華，子孫滿堂。",
    aspects: {
      家宅: "家運極旺，富貴榮華，子孫滿堂",
      事業: "事業大成，名利雙收，前程似錦",
      學業: "學業有成，金榜題名，前途光明",
      命運: "運勢極佳，龍鳳呈祥，諸事大吉",
      健康: "身體健康，精神飽滿，長壽之相",
      感情: "感情美滿，龍鳳配對，白頭偕老"
    },
    level: '上上'
  },
  {
    id: 29,
    title: "第二十九簽 上中 古人漁樵問答",
    poem: "漁樵問答話桑麻\n淡泊名利樂無涯\n知足常樂是真福\n清心寡慾壽如山",
    meaning: "此簽表示淡泊名利，知足常樂，清心寡慾，健康長壽。",
    aspects: {
      家宅: "家庭和睦，淡泊名利，其樂融融",
      事業: "事業穩定，不求大富大貴，知足常樂",
      學業: "學業平穩，不求名次，重在學習",
      命運: "運勢平和，知足常樂，心境平和",
      健康: "身心健康，清心寡慾，延年益壽",
      感情: "感情穩定，相敬如賓，平淡是福"
    },
    level: '上中'
  },
  {
    id: 30,
    title: "第三十簽 上下 古人程門立雪",
    poem: "程門立雪求學心\n尊師重道品格深\n虛心學習必有成\n師父領進門修行",
    meaning: "此簽勉勵要尊師重道，虛心學習，必有所成。",
    aspects: {
      家宅: "家庭要尊敬長輩，虛心學習，家風良好",
      事業: "事業要尊重前輩，虛心學習，必有進步",
      學業: "學業要尊師重道，虛心求教，必有所成",
      命運: "運勢良好，虛心學習，不斷進步",
      健康: "身體健康，虛心求醫，注意保養",
      感情: "感情要虛心學習，相互尊重，和睦相處"
    },
    level: '上下'
  },
  // 繼續添加更多簽文到60簽...
  {
    id: 31,
    title: "第三十一簽 中上 古人鶴立雞群",
    poem: "鶴立雞群品格高\n出類拔萃眾人誇\n才華橫溢人中龍\n前程似錦步步高",
    meaning: "此簽表示才華出眾，品格高尚，前程遠大。",
    aspects: {
      家宅: "家中有才子，出類拔萃，光宗耀祖",
      事業: "事業出眾，才華橫溢，升職有望",
      學業: "學業優秀，出類拔萃，名列前茅",
      命運: "運勢良好，才華得到認可，前程遠大",
      健康: "身體健康，精神飽滿，神采奕奕",
      感情: "感情順利，才貌雙全，佳偶天成"
    },
    level: '中上'
  },
  {
    id: 32,
    title: "第三十二簽 中中 古人螳螂捕蟬",
    poem: "螳螂捕蟬黃雀後\n只見眼前不見後\n謀事要看全局面\n一葉障目不可取",
    meaning: "此簽提醒要看全局，不可只顧眼前，要有遠見。",
    aspects: {
      家宅: "家庭決策要看長遠，不可只顧眼前利益",
      事業: "事業規劃要全面，不可短視近利",
      學業: "學習要全面發展，不可偏科",
      命運: "運勢需要全面考慮，不可一葉障目",
      健康: "身體保養要全面，不可顧此失彼",
      感情: "感情要考慮長遠，不可只看外表"
    },
    level: '中中'
  },
  {
    id: 33,
    title: "第三十三簽 中下 古人買櫝還珠",
    poem: "買櫝還珠不識貨\n捨本逐末失真諦\n外表華麗非重點\n內在品質才珍貴",
    meaning: "此簽警示不要捨本逐末，要重視內在品質。",
    aspects: {
      家宅: "家庭不要只重外表，要注重內在和睦",
      事業: "事業不要只看表面，要重視實質內容",
      學業: "學習不要只重成績，要重視品德修養",
      命運: "運勢要重視內在修養，不可只看外表",
      健康: "身體不要只重外表，要注重內在健康",
      感情: "感情不要只看外貌，要重視內在品格"
    },
    level: '中下'
  },
  {
    id: 34,
    title: "第三十四簽 下上 古人臥冰求鯉",
    poem: "臥冰求鯉孝心深\n至誠感動天地神\n孝順父母天倫樂\n善有善報福自臨",
    meaning: "此簽勉勵要孝順父母，至誠感動天地，必有福報。",
    aspects: {
      家宅: "家庭要孝順父母，天倫之樂，福報自來",
      事業: "事業要誠心待人，至誠感人，必有成就",
      學業: "學業要誠心求學，至誠感師，必有進步",
      命運: "運勢因孝順而轉好，善有善報",
      健康: "身體因孝心而健康，心情愉悅",
      感情: "感情要真誠相待，至誠感人，必有回報"
    },
    level: '下上'
  },
  {
    id: 35,
    title: "第三十五簽 下中 古人東施效顰",
    poem: "東施效顰不自量\n盲目模仿失本相\n做人要有自知明\n發揮所長才是王",
    meaning: "此簽警示不要盲目模仿，要有自知之明，發揮自己的長處。",
    aspects: {
      家宅: "家庭要有自己的特色，不要盲目攀比",
      事業: "事業要發揮自己的長處，不要盲目模仿",
      學業: "學習要有自己的方法，不要盲目跟風",
      命運: "運勢要發揮自己的優勢，不要妄自菲薄",
      健康: "身體要根據自己的情況保養，不要盲從",
      感情: "感情要做真實的自己，不要刻意模仿"
    },
    level: '下中'
  },
  {
    id: 36,
    title: "第三十六簽 下下 古人夜郎自大",
    poem: "夜郎自大不知天\n坐井觀天見識淺\n謙虛謹慎是美德\n驕傲自滿必敗事",
    meaning: "此簽警示不要驕傲自大，要謙虛謹慎，見識要廣。",
    aspects: {
      家宅: "家庭要謙虛低調，不要驕傲自大",
      事業: "事業要謙虛謹慎，不要夜郎自大",
      學業: "學習要謙虛求教，不要自以為是",
      命運: "運勢需要謙虛，驕傲必敗",
      健康: "身體要謙虛求醫，不要諱疾忌醫",
      感情: "感情要謙虛相處，不要高傲自大"
    },
    level: '下下'
  },
  {
    id: 37,
    title: "第三十七簽 上上 古人麒麟送子",
    poem: "麒麟送子降祥瑞\n天賜貴子福滿門\n子孫滿堂家業旺\n世代書香傳美名",
    meaning: "此簽大吉，特別利於求子，天賜貴子，家業興旺。",
    aspects: {
      家宅: "家有貴子降生，子孫滿堂，家業興旺",
      事業: "事業如得貴子，蒸蒸日上，前程似錦",
      學業: "學業有成，如麒麟之子，才華橫溢",
      命運: "運勢極佳，天降祥瑞，諸事大吉",
      健康: "身體健康，生育順利，母子平安",
      感情: "感情美滿，早生貴子，家庭幸福"
    },
    level: '上上'
  },
  {
    id: 38,
    title: "第三十八簽 上中 古人漁翁得利",
    poem: "鷸蚌相爭漁翁利\n坐山觀虎鬥智謀\n不爭不搶得便宜\n以靜制動是良策",
    meaning: "此簽表示以靜制動，不爭不搶，反而能得到好處。",
    aspects: {
      家宅: "家庭和睦，不爭不搶，反而得利",
      事業: "事業以靜制動，不急不躁，反有收穫",
      學業: "學習穩紮穩打，不急功近利，反有進步",
      命運: "運勢以靜制動，不爭不搶，反得好運",
      健康: "身體以靜養生，不急不躁，反得健康",
      感情: "感情以靜制動，不爭不吵，反得和睦"
    },
    level: '上中'
  },
  {
    id: 39,
    title: "第三十九簽 上下 古人囊螢映雪",
    poem: "囊螢映雪苦讀書\n貧寒不改求學志\n天道酬勤終有報\n寒門出貴子可期",
    meaning: "此簽勉勵在困境中要堅持學習，天道酬勤，終有成就。",
    aspects: {
      家宅: "家庭雖貧寒，但子女有志，終能出頭",
      事業: "事業雖困難，但堅持努力，終有成就",
      學業: "學業雖困苦，但勤奮好學，必有所成",
      命運: "運勢雖不佳，但努力不懈，終有轉機",
      健康: "身體雖不佳，但堅持鍛煉，必能改善",
      感情: "感情雖困難，但真心不變，終成正果"
    },
    level: '上下'
  },
  {
    id: 40,
    title: "第四十簽 中上 古人洛陽紙貴",
    poem: "洛陽紙貴文章好\n才華橫溢名聲高\n文以載道傳千古\n筆下生花世人誇",
    meaning: "此簽表示文才出眾，名聲遠播，文章傳世。",
    aspects: {
      家宅: "家中有文才，名聲遠播，光宗耀祖",
      事業: "事業因文才而成功，名利雙收",
      學業: "學業優秀，文才出眾，前途光明",
      命運: "運勢因才華而轉好，名聲遠播",
      健康: "身心健康，才思敏捷，精神飽滿",
      感情: "感情因才華而美滿，才子佳人"
    },
    level: '中上'
  },
  {
    id: 41,
    title: "第四十一簽 中中 古人畫龍點睛",
    poem: "畫龍點睛神來筆\n關鍵時刻顯身手\n抓住要點是關鍵\n一語中的見真功",
    meaning: "此簽表示要抓住關鍵，在關鍵時刻發揮作用。",
    aspects: {
      家宅: "家庭要抓住關鍵問題，一語中的解決",
      事業: "事業要抓住關鍵機會，畫龍點睛成功",
      學業: "學習要抓住重點，畫龍點睛提高成績",
      命運: "運勢要抓住關鍵時機，一舉成功",
      健康: "身體要抓住關鍵問題，對症下藥",
      感情: "感情要抓住關鍵時刻，表達真心"
    },
    level: '中中'
  },
  {
    id: 42,
    title: "第四十二簽 中下 古人葉公好龍",
    poem: "葉公好龍非真愛\n口是心非假情懷\n真假難辨需慎重\n言行一致才可靠",
    meaning: "此簽警示要言行一致，不可口是心非，要真心實意。",
    aspects: {
      家宅: "家庭要真心相待，不可口是心非",
      事業: "事業要言行一致，不可表裡不一",
      學業: "學習要真心求學，不可虛假應付",
      命運: "運勢需要真心實意，不可虛假偽裝",
      健康: "身體要真實面對，不可諱疾忌醫",
      感情: "感情要真心相愛，不可虛情假意"
    },
    level: '中下'
  },
  {
    id: 43,
    title: "第四十三簽 下上 古人鐵杵磨針",
    poem: "鐵杵磨針功夫深\n只要功夫深鐵杵\n磨成繡花針可能\n持之以恆必成功",
    meaning: "此簽勉勵要有恆心毅力，持之以恆，必能成功。",
    aspects: {
      家宅: "家庭需要持之以恆的經營，必有成果",
      事業: "事業需要持續努力，鐵杵磨針必成功",
      學業: "學習需要持之以恆，必有所成",
      命運: "運勢需要持續努力，持之以恆見成效",
      健康: "身體需要持續保養，持之以恆得健康",
      感情: "感情需要持續經營，持之以恆得幸福"
    },
    level: '下上'
  },
  {
    id: 44,
    title: "第四十四簽 下中 古人邯鄲學步",
    poem: "邯鄲學步失本能\n盲目學習反不成\n保持本色最重要\n適合自己才是真",
    meaning: "此簽警示不要盲目學習，要保持本色，適合自己最重要。",
    aspects: {
      家宅: "家庭要保持本色，不要盲目攀比",
      事業: "事業要發揮本能，不要盲目模仿",
      學業: "學習要保持自己的方法，不要邯鄲學步",
      命運: "運勢要發揮自己的優勢，不要迷失本性",
      健康: "身體要根據自己的情況，不要盲目跟風",
      感情: "感情要保持真我，不要刻意改變"
    },
    level: '下中'
  },
  {
    id: 45,
    title: "第四十五簽 下下 古人緣木求魚",
    poem: "緣木求魚方法錯\n南轅北轍難成功\n方向不對努力空\n找對方法是關鍵",
    meaning: "此簽警示方法要正確，方向不對努力也是徒勞。",
    aspects: {
      家宅: "家庭問題要找對方法解決，不可緣木求魚",
      事業: "事業要找對方向，方法不對努力白費",
      學業: "學習要找對方法，不可南轅北轍",
      命運: "運勢要找對方向，方法正確才有效",
      健康: "身體要找對治療方法，不可病急亂投醫",
      感情: "感情要找對方法經營，不可緣木求魚"
    },
    level: '下下'
  },
  {
    id: 46,
    title: "第四十六簽 上上 古人鳳求凰",
    poem: "鳳求凰琴聲美\n才子佳人天作配\n音律和諧情意深\n琴瑟和鳴百年好",
    meaning: "此簽大吉，特別利於感情，才子佳人，琴瑟和鳴。",
    aspects: {
      家宅: "家庭和諧，夫妻恩愛，琴瑟和鳴",
      事業: "事業如鳳求凰，合作愉快，成功在望",
      學業: "學業如琴瑟和鳴，師生和諧，進步神速",
      命運: "運勢極佳，如鳳求凰，心想事成",
      健康: "身心和諧，如琴瑟和鳴，健康長壽",
      感情: "感情極佳，鳳求凰配，白頭偕老"
    },
    level: '上上'
  },
  {
    id: 47,
    title: "第四十七簽 上中 古人高山流水",
    poem: "高山流水遇知音\n伯牙子期情意深\n知己難求千里外\n一曲相知勝萬金",
    meaning: "此簽表示將遇知音，知己難求，友情深厚。",
    aspects: {
      家宅: "家庭和睦，家人如知音，相知相惜",
      事業: "事業遇貴人，如高山流水遇知音",
      學業: "學業得良師，如伯牙遇子期",
      命運: "運勢良好，遇知音貴人，相助成功",
      健康: "身心健康，遇良醫如知音",
      感情: "感情深厚，如高山流水，知音難求"
    },
    level: '上中'
  },
  {
    id: 48,
    title: "第四十八簽 上下 古人毛遂自薦",
    poem: "毛遂自薦顯才能\n機會要靠自己爭\n不鳴則已一鳴驚\n自信勇敢必成功",
    meaning: "此簽勉勵要自信勇敢，主動爭取機會，展現才能。",
    aspects: {
      家宅: "家庭要主動承擔責任，展現能力",
      事業: "事業要毛遂自薦，主動爭取機會",
      學業: "學業要主動表現，展現才華",
      命運: "運勢要主動爭取，自信勇敢必成功",
      健康: "身體要主動保養，積極治療",
      感情: "感情要主動表達，勇敢追求"
    },
    level: '上下'
  },
  {
    id: 49,
    title: "第四十九簽 中上 古人竹林七賢",
    poem: "竹林七賢品格高\n超然物外樂逍遙\n不為名利所束縛\n清風明月伴終老",
    meaning: "此簽表示品格高尚，超然物外，不為名利所累。",
    aspects: {
      家宅: "家庭清雅，品格高尚，超然物外",
      事業: "事業穩定，不為名利所累，心境平和",
      學業: "學業清高，不為名次所累，重在修養",
      命運: "運勢平和，品格高尚，超然物外",
      健康: "身心清淨，不為俗事所累，健康長壽",
      感情: "感情清雅，不為物質所累，精神相通"
    },
    level: '中上'
  },
  {
    id: 50,
    title: "第五十簽 中中 古人半途而廢",
    poem: "半途而廢功虧簣\n堅持到底是關鍵\n成功就在最後步\n千萬不可輕言棄",
    meaning: "此簽警示不可半途而廢，要堅持到底，成功就在眼前。",
    aspects: {
      家宅: "家庭事務要堅持到底，不可半途而廢",
      事業: "事業要堅持到底，成功就在最後一步",
      學業: "學習要堅持到底，不可半途而廢",
      命運: "運勢要堅持努力，不可輕言放棄",
      健康: "身體治療要堅持，不可半途而廢",
      感情: "感情要堅持經營，不可半途而廢"
    },
    level: '中中'
  },
  {
    id: 51,
    title: "第五十一簽 中下 古人刻舟求劍",
    poem: "刻舟求劍不知變\n固執己見路難行\n時移世易須應變\n靈活變通始得成",
    meaning: "此簽提醒要懂得變通，不可固執己見，要隨機應變。",
    aspects: {
      家宅: "家庭關係需要調整，不可過於固執",
      事業: "事業遇到瓶頸，需要改變策略和方法",
      學業: "學習方法需要調整，不可死讀書",
      命運: "運勢需要轉變思維，靈活應對",
      健康: "身體需要調養，改變不良習慣",
      感情: "感情需要溝通，不可一意孤行"
    },
    level: '中下'
  },
  {
    id: 52,
    title: "第五十二簽 下上 古人懸樑刺股",
    poem: "懸樑刺股苦讀書\n勤學苦練志不移\n寒窗十載無人問\n一舉成名天下知",
    meaning: "此簽勉勵要勤學苦練，雖然辛苦，但終能成名。",
    aspects: {
      家宅: "家庭雖苦，但勤勞致富，終有所成",
      事業: "事業雖苦，但勤奮努力，終能成功",
      學業: "學業雖苦，但勤學苦練，必有所成",
      命運: "運勢雖苦，但堅持努力，終有轉機",
      健康: "身體雖苦，但堅持鍛煉，必能強健",
      感情: "感情雖苦，但真心不變，終成正果"
    },
    level: '下上'
  },
  {
    id: 53,
    title: "第五十三簽 下中 古人畫蛇添足",
    poem: "畫蛇添足多此舉\n節外生枝反不美\n適可而止是智慧\n過猶不及要謹記",
    meaning: "此簽警示要適可而止，不可畫蛇添足，過猶不及。",
    aspects: {
      家宅: "家庭要適可而止，不可過度干預",
      事業: "事業要適可而止，不可畫蛇添足",
      學業: "學習要適可而止，不可過度用功",
      命運: "運勢要適可而止，不可貪得無厭",
      健康: "身體要適可而止，不可過度勞累",
      感情: "感情要適可而止，不可過度纏綿"
    },
    level: '下中'
  },
  {
    id: 54,
    title: "第五十四簽 下下 古人空中樓閣",
    poem: "空中樓閣不實際\n虛無縹緲難成真\n腳踏實地是正道\n實事求是方成功",
    meaning: "此簽警示不要好高騖遠，要腳踏實地，實事求是。",
    aspects: {
      家宅: "家庭要實際，不可好高騖遠",
      事業: "事業要腳踏實地，不可空中樓閣",
      學業: "學習要實事求是，不可虛無縹緲",
      命運: "運勢要實際，不可幻想空中樓閣",
      健康: "身體要實際保養，不可幻想靈丹妙藥",
      感情: "感情要實際，不可幻想完美愛情"
    },
    level: '下下'
  },
  {
    id: 55,
    title: "第五十五簽 上上 古人雙龍戲珠",
    poem: "雙龍戲珠瑞氣生\n龍鳳呈祥福滿門\n陰陽調和萬事興\n夫妻和睦子孫榮",
    meaning: "此簽大吉，雙龍戲珠，陰陽調和，夫妻和睦，萬事興旺。",
    aspects: {
      家宅: "家庭和睦，陰陽調和，子孫滿堂",
      事業: "事業興旺，合作愉快，雙贏局面",
      學業: "學業有成，文武雙全，前途光明",
      命運: "運勢極佳，陰陽調和，諸事大吉",
      健康: "身體健康，陰陽平衡，精神飽滿",
      感情: "感情美滿，夫妻和睦，白頭偕老"
    },
    level: '上上'
  },
  {
    id: 56,
    title: "第五十六簽 上中 古人桃園結義",
    poem: "桃園結義情義深\n生死與共不離分\n義薄雲天感天地\n患難與共見真心",
    meaning: "此簽表示友情深厚，義薄雲天，患難與共。",
    aspects: {
      家宅: "家庭團結，兄弟和睦，患難與共",
      事業: "事業合作，義薄雲天，共創佳績",
      學業: "學業得友相助，患難與共，共同進步",
      命運: "運勢得友相助，義薄雲天，逢凶化吉",
      健康: "身體得友關懷，患難與共，早日康復",
      感情: "感情深厚，患難與共，生死不渝"
    },
    level: '上中'
  },
  {
    id: 57,
    title: "第五十七簽 上下 古人臥薪嘗膽",
    poem: "臥薪嘗膽志不移\n十年磨劍為今時\n苦盡甘來終有日\n一朝得志震天威",
    meaning: "此簽勉勵在困境中要堅持，經過磨練必能成功。",
    aspects: {
      家宅: "家庭暫時困難，但堅持必能改善",
      事業: "事業處於低潮，需要堅持和努力",
      學業: "學習遇到困難，但不可放棄",
      命運: "運勢暫時不佳，但堅持必有轉機",
      健康: "身體需要調養，注意休息",
      感情: "感情遇到考驗，真愛必能度過難關"
    },
    level: '上下'
  },
  {
    id: 58,
    title: "第五十八簽 中上 古人八仙過海",
    poem: "八仙過海各顯神\n各有本領各有能\n發揮所長展才華\n團結合作力無窮",
    meaning: "此簽表示要發揮各自的長處，團結合作，力量無窮。",
    aspects: {
      家宅: "家庭成員各有所長，團結合作，家業興旺",
      事業: "事業團隊各顯神通，合作無間，成功在望",
      學業: "學習各有專長，互相學習，共同進步",
      命運: "運勢要發揮所長，團結他人，力量無窮",
      健康: "身體各部位協調，整體健康，精神飽滿",
      感情: "感情各有特色，互補不足，和諧美滿"
    },
    level: '中上'
  },
  {
    id: 59,
    title: "第五十九簽 中中 古人守株待兔",
    poem: "守株待兔古人愚\n坐享其成豈可求\n天道酬勤是真理\n勤勞致富福自修",
    meaning: "此簽警示不可坐享其成，要勤勞努力，天道酬勤。",
    aspects: {
      家宅: "家庭平穩，但不可懈怠，需要努力維持",
      事業: "事業平平，需要主動出擊，不可守株待兔",
      學業: "學業一般，需要加倍努力，不可偷懶",
      命運: "運勢平平，需要自己努力改變現狀",
      健康: "身體無大礙，但需要注意保養",
      感情: "感情平淡，需要主動經營，增進感情"
    },
    level: '中中'
  },
  {
    id: 60,
    title: "第六十簽 中下 古人大器晚成",
    poem: "大器晚成不用急\n厚積薄發有時機\n年少不得志莫憂\n中年以後必有為",
    meaning: "此簽勉勵不要急躁，大器晚成，厚積薄發，中年以後必有作為。",
    aspects: {
      家宅: "家庭大器晚成，中年以後家業興旺",
      事業: "事業大器晚成，厚積薄發，中年有成",
      學業: "學業大器晚成，不要急躁，持續努力",
      命運: "運勢大器晚成，中年以後運勢轉好",
      健康: "身體大器晚成，中年以後注意保養",
      感情: "感情大器晚成，中年以後感情穩定"
    },
    level: '中下'
  }
];

// 獲取農曆日期的函數
export const getLunarDate = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  
  // 簡化的農曆轉換（實際應用中需要更精確的農曆算法）
  const lunarMonths = ['正月', '二月', '三月', '四月', '五月', '六月', 
                      '七月', '八月', '九月', '十月', '十一月', '十二月'];
  const lunarDays = ['初一', '初二', '初三', '初四', '初五', '初六', '初七', '初八', '初九', '初十',
                    '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十',
                    '廿一', '廿二', '廿三', '廿四', '廿五', '廿六', '廿七', '廿八', '廿九', '三十'];
  
  // 簡化計算（實際需要複雜的農曆算法）
  const lunarMonth = lunarMonths[(month - 1) % 12];
  const lunarDay = lunarDays[(day - 1) % 30];
  
  return `農曆${lunarMonth}${lunarDay}`;
};

// 隨機抽取簽號
export const getRandomSign = (): FortuneSign => {
  const randomIndex = Math.floor(Math.random() * fortuneSigns.length);
  return fortuneSigns[randomIndex];
};

// 根據簽號獲取簽文
export const getSignById = (id: number): FortuneSign | null => {
  return fortuneSigns.find(sign => sign.id === id) || null;
};